<template>
  <v-autocomplete
    label="Выберите параметр"
    persistent-hint
    hide-no-data
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :return-object="returnObject"
    :loading="loading"
    :items="items"
  />
</template>

<script>
import { ParamsService } from "@/services/api/params.service.js";

export default {
  name: "AutocompleteMedParams",

  props: {
    returnObject: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      search: null,
      items: [],
    };
  },

  async created() {
    this.items = await ParamsService.getAll();
  },
};
</script>

<style scoped></style>
